import React from 'react'
import PropTypes from 'prop-types'

const ListingHeader = ({ heading, totalCount }) => {
  return (
    <div className='ListingGroup-headingBlock'>
      <p className='ListingGroup-headingText'>
        {heading}
      </p>
      <span className='ListingGroup-searchResultsCount'>
        {`${totalCount} Results`}
      </span>
    </div>
  )
}

ListingHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  totalCount: PropTypes.string.isRequired
}

export default ListingHeader
